/** A value the UI can subscribe to, so it reacts to a change without polling for one. */
export interface NotifiableValue<T> {
  get(): T;
  set(next: T): void;
  /** Returns an unsubscribe function. */
  onChange(listener: () => void): () => void;
}

export function notifiableValue<T>(initial: T): NotifiableValue<T> {
  let value = initial;
  const listeners = new Set<() => void>();

  return {
    get: () => value,
    set: (next: T) => {
      if (next === value) {
        return;
      }
      value = next;
      for (const listener of Array.from(listeners)) {
        listener();
      }
    },
    onChange: (listener: () => void) => {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    },
  };
}
